module.exports = __webpack_public_path__ + "img/commerceA.f0ff82fa.png";